import React from "react";
import { useTranslation } from "react-i18next";
import { Link as MuiLink, Typography } from "@mui/material";
import { Link } from "react-router";

export const LoginPageSignupQuestion = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Typography variant="body3" align="center" color="textSecondary">
        {t("loginPage.signupMessage.question")}{" "}
        <MuiLink component={Link} to="/signup" underline="hover">
          {t("loginPage.signupMessage.link")}
        </MuiLink>
      </Typography>
      <Typography variant="body3" align="center" color="textSecondary">
        {t("loginPage.resetPassword.question")}{" "}
        <MuiLink component={Link} to="/reset/password" underline="hover">
          {t("loginPage.resetPassword.link")}
        </MuiLink>
      </Typography>
    </div>
  );
};
